import { Component, inject, input, output } from "@angular/core";
import { AccumateModule, MODULE_NAMES } from "src/app/shared/consts/icon-features";
import { HeaderLocationService } from "@services/header-location.service";
import { ConfigService } from "src/app/shared/services/config.service";
import { MatMenu, MatMenuTrigger } from "@angular/material/menu";
import { SUPPORTED_LANGUAGES } from "src/app/shared/consts/supported-languages";
import { InitResponse } from "src/app/shared/contract/Init/InitDataResponse";
import { FeatureIconViewModel } from "src/app/shared/services/header-navigation.service";
import { PackageService } from "../../reception/package.service";
import { ReceptionService } from "../../reception/reception.service";
import { MatIcon } from "@angular/material/icon";
import { SearchInputComponent } from "./search-input/search-input.component";
import { MatChipListbox, MatChipOption } from "@angular/material/chips";
import { MatFormField } from "@angular/material/form-field";
import { MatOption, MatSelect } from "@angular/material/select";
import { MatButton } from "@angular/material/button";
import { NgClass, UpperCasePipe } from "@angular/common";
import { UserMenuComponent } from "../user-menu/user-menu.component";
import { TranslocoPipe } from "@jsverse/transloco";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.scss",
  imports: [
    MatIcon,
    SearchInputComponent,
    MatFormField,
    MatSelect,
    MatOption,
    MatButton,
    MatMenuTrigger,
    NgClass,
    MatMenu,
    UserMenuComponent,
    UpperCasePipe,
    TranslocoPipe,
    MatChipListbox,
    MatChipOption
  ]
})
export class HeaderComponent {
  readonly packageService = inject(PackageService);
  readonly receptionService = inject(ReceptionService);
  readonly configService = inject(ConfigService);
  readonly headerLocationService = inject(HeaderLocationService);

  hasChangeRightPermission = input(false);
  hasShopPermission = input(false);
  hasAppSynchronizationPermission = input(false);
  navigationItems = input<FeatureIconViewModel[]>([]);
  initData = input<InitResponse>(null);
  userLocale = input<string>(null);
  quota = input(0);

  languageChanged = output<string>();
  openCacheClicked = output<void>();
  goToHomeClicked = output<void>();
  navigationItemClicked = output<AccumateModule>();

  readonly languageItems = SUPPORTED_LANGUAGES;

  changeNavigationItem(id: string) {
    const moduleNames = Object.values(MODULE_NAMES) as AccumateModule[];

    if (!moduleNames.includes(id as AccumateModule)) {
      return;
    }

    const mode = id as AccumateModule;
    this.navigationItemClicked.emit(mode);
  }

  goToHomeKeyUp(event: KeyboardEvent) {
    if (event.key === "Enter") {
      this.goToHomeClicked.emit();
    }
  }
}
